module.exports = __webpack_public_path__ + "img/logo-foot.3b5b390.png";